import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {forkJoin} from 'rxjs';
import {RbdSimpleModel} from '../../../../modelos/rbd-simple.model';
import {DocumentosService} from '../../../../servicios/documentos.service';
import {RbdService} from '../../../../servicios/rbd.service';
import {ResultadoGeneralModel} from '../../../../modelos/resultado-general.model';
import {RbdResultadoGeneralBasicaModel} from '../../../../modelos/rbd-resultado-general-basica.model';
import {Router , ActivatedRoute} from '@angular/router';
import {ItmeResultadoGeneralModel} from '../../../../modelos/itme-resultado-general.model';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {TrackingService} from '../../../../servicios/tracking.service';
import {ExportacionService} from '../../../../servicios/exportacion.service';
import {RbdModel} from '../../../../modelos/rbd.model';
import {LoginModel} from '../../../../modelos/login.model';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {PortalModel} from '../../../../modelos/portal.model';
import {KeycloakService} from '../../../../servicios/keycloak.service';

@Component({
  selector: 'app-mineduc-basica',
  templateUrl: './mineduc-basica.component.html',
  styleUrls: ['./mineduc-basica.component.css']
})
export class MineducBasicaComponent implements OnInit {

  @Output() cambioPortal: EventEmitter<any> = new EventEmitter();

  public perfil: number;
  public rbd: any;
  public rbdSeleccion: any;
  public keyword = 'nombreCompleto';
  public listaRBD: RbdSimpleModel[] = [];
  public listaRBDAsociados: RbdResultadoGeneralBasicaModel[] = [];
  public listaEstablecimientos: RbdSimpleModel[] = [];
  public rbdModel: RbdModel = new RbdModel();

  public userData: any;
  /*public establecimientos: Observable<RbdResultadoGeneralModel[]>;*/

  public storeGrilla: RbdResultadoGeneralBasicaModel[] = [];
  public grillaResultadosGenerales: ItmeResultadoGeneralModel;

  public page = 1;
  public pageSize = 10;
  public collectionSize = 0;
  public portalId = 3;

  public rbds: any[] = [];

  public anioSeleccion = 2019;

  public tablaGenerales: ResultadoGeneralModel = new ResultadoGeneralModel();

  public tieneBasica = false;
  public tieneMedia = false;

  show;
  show2;

  p4bLect: string;
  tab4bLect: number;

  p6bLect: string;
  tab6bLect: number;

  p4bMat: string;
  tab4bMat: number;

  p6bMat: string;
  tab6bMat: number;

  url2016: SafeResourceUrl;
  url2017: SafeResourceUrl;
  url2018: SafeResourceUrl;

  url2019;

  public datosMat4basico: any;
  public datosMat6basico: any;
  public datosLect4basico: any;
  public datosLect6basico: any;

  public loginModel: LoginModel = new LoginModel();

  public portalModel: PortalModel;
  public urlIndicador: string;

  constructor(private rbdService: RbdService,
              private router: Router,
              private route: ActivatedRoute,
              private ngxService: NgxUiLoaderService,
              public tracking: TrackingService,
              private domSanitizer: DomSanitizer,
              private keycloakService: KeycloakService,
              private exportacionService: ExportacionService,
              private documentosService: DocumentosService) {
    this.route.params.subscribe((pathParams) => {
      if (pathParams.rbd) {
        this.keycloakService.validarAccesoRbd(pathParams.rbd);
      }
    });
  }

  ngOnInit() {
    this.tab4bLect = -1;
    this.tab6bLect = -1;
    this.tab4bMat = -1;
    this.tab6bMat = -1;

    const subscribes = [];
    subscribes.push(this.documentosService.obtenerUrlDocByNombre('MetConstruccionIDPS-dic-2016'));

    forkJoin(subscribes).subscribe(
      (result) => {
        this.urlIndicador = result[0].url;
      });

    this.route.params.subscribe((pathParams) => {
      if (pathParams.rbd) {
        this.rbd = pathParams.rbd;
        this.loginModel.perfil = 8;
        this.obtnerRbd(this.rbd);
        this.portalModel = this.tracking.obtenerNombrePorta(this.loginModel.perfil, 'basica');
      }
    });

  }

  /**
   * Metodo que se encarga de obtener los datos segun el RBD
   *
   * @param rbd
   */
  obtnerRbd(rbd: string): void {
    this.ngxService.start();
    const subscribes = [];
    const rbds: string[] = [];
    this.userData = JSON.parse(localStorage.getItem('UserData'));
    console.log(this.userData);

    if (this.userData.autoridad && this.userData.autoridad.length > 0) {
      rbds.push(...this.userData.autoridad);
    }
    subscribes.push(this.rbdService.buscar2('basica', rbd));
    subscribes.push(this.rbdService.anioPrueba(rbd));
    subscribes.push(this.rbdService.resumenEstadistico(null, null, rbds.toString(), this.userData.rut, this.userData.rol));

    forkJoin(subscribes).subscribe(
      (result) => {
        const establecimiento = this.rbdModel.procesarEstablecimientoBasica(result[1]);
        this.datosMat4basico = establecimiento.datosMat4basico;
        this.datosMat6basico = establecimiento.datosMat6basico;
        this.datosLect4basico = establecimiento.datosLect4basico;
        this.datosLect6basico = establecimiento.datosLect6basico;
        this.rbdModel = new RbdModel(result[0]);
        this.listaRBD = result[2];
        this.listaRBDAsociados = result[2];
        this.storeGrilla = result[2];
        this.ngxService.stop();
      }, error => {
        this.ngxService.stop();
        console.log(error);
        if (error.status === 404) {
          alert('Estimado usuario el RBD consultado no existe.');
          window.location.href = 'https://agenciaeducacion.cl/';
        }
      });
  }

  /*isLoggedIn(message: string, loggedIn: boolean): void {
    if (loggedIn) {
      this.userData = JSON.parse(localStorage.getItem('UserData'));
      this.perfil = this.userData.perfil;
      this.buscarResumenEstadistico();

    } else {
      this.router.navigate(['/']);
    }
  }*/

  irPortal(rbd: string, portal: string, tipo: string) {
    this.router.navigate(['/' + portal + '/' + tipo + (null !== rbd ? '/' + rbd : '')]);
  }

  irPortalAutoridad(tipo: string) {
    this.router.navigate(['/autoridad/' + tipo]);
  }

  selectEvent(item) {
    console.log(item);
    this.rbdSeleccion = item;
    this.storeGrilla = [];
    this.storeGrilla = this.listaRBDAsociados.filter(x => x.rbd === this.rbdSeleccion.rbd);
    console.log(this.storeGrilla);
  }

  limpiarBuscador(event) {
    this.storeGrilla = [];
    this.storeGrilla = this.listaRBDAsociados;
  }

  onChangeSearch(search: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
    if (search && (!isNaN(Number(search)) || search.length > 2)) {
      this.rbdService.filtrarRbd(search).subscribe(
        next => {
          this.listaRBD = next;
          this.rbdSeleccion = null;
        },
        error => {
          this.listaRBD = [];
          this.rbdSeleccion = null;
        }
      );
    } else {
      this.listaRBD = [];
      this.rbdSeleccion = null;
    }
  }

  /*onChangeSearch(search: string) {
    if (search && (!isNaN(Number(search)) || search.length > 2)) {
      this.rbdService.filtrarRbd(search).subscribe(
        next => {
          this.listaRBD = next.filter(n => this.rbds.includes(n.rbd));
        },
        error => {
          this.listaRBD = [];
        }
      );
    } else {
      this.listaRBD = [];
    }
  }*/

  onFocused(e) {
    console.log(e);
  }

  establecimientosCombo() {
    this.rbds = [];
    this.listaRBDAsociados.forEach(x => {
      this.rbds.push(x.rbd);
      this.listaEstablecimientos.push(this.listaRBD.find(r => r.rbd === parseInt(x.rbd, null)));
    });
  }

  buscarResumenEstadistico() {
    this.ngxService.start();

    const subscribes = [];

    if (this.userData.rol === 'nacional') {
      subscribes.push(this.rbdService.resumenNacional('basica'));
    } else {
      const rbds: string[] = [];
      if (this.userData.sostenedor && this.userData.sostenedor.length > 0) {
        rbds.push(...this.userData.sostenedor);
      }

      if (this.userData.autoridad && this.userData.autoridad.length > 0) {
        rbds.push(...this.userData.autoridad);
      }
      console.log(this.userData);
      subscribes.push(this.rbdService.resumenEstadistico(null, null, rbds.toString(), this.userData.rut, this.userData.rol));
      subscribes.push(this.rbdService.buscarDatos(this.userData.rol, this.userData.rut));
    }

    forkJoin(subscribes).subscribe(
      (result: any[]) => {
        this.listaRBDAsociados = result[0];
        /*this.getEstablecimientos(this.listaRBDAsociados);*/
        this.storeGrilla = result[0];
        this.establecimientosCombo();
        /*this.getEstablecimientos(next);*/
        /*this.collectionSize = next.length;*/
        this.procesarResumen(result[0], this.anioSeleccion);

        if (this.userData.rol === 'nacional') {
          this.tieneBasica = true;
          this.tieneMedia = true;
        } else {
          this.tieneBasica = result[1].tieneBasica;
          this.tieneMedia = result[1].tieneMedia;
        }

        this.ngxService.stop();
      },
      (error: any) => {
        this.ngxService.stop();
        console.log(error);
      }
    );
  }

  procesarResumen(lista: RbdResultadoGeneralBasicaModel[], anio: number) {
    lista.forEach(rbd => {
      switch (rbd['categoriaDes' + this.anioSeleccion]) {
        /*switch (rbd.categoriaDes2019) {*/
        case '1':
          /*descripcion = 'Alto';*/
          this.tablaGenerales.totalAlto += 1;
          this.tablaGenerales.totalMatriculaAlto += parseInt(rbd.matBasica, null);
          break;
        case '2':
          /*descripcion = 'Medio';*/
          this.tablaGenerales.totalMedio += 1;
          this.tablaGenerales.totalMatriculaMedio += parseInt(rbd.matBasica, null);
          break;
        case '3':
          /* descripcion = 'Medio-Bajo';*/
          this.tablaGenerales.totalMedioBajo += 1;
          this.tablaGenerales.totalMatriculaMedioBajo += parseInt(rbd.matBasica, null);
          break;
        case '4':
          /*descripcion = 'Insuficiente';*/
          this.tablaGenerales.totalInsuficiente += 1;
          this.tablaGenerales.totalMatriculaInsuficiente += parseInt(rbd.matBasica, null);
          break;
        case '99999':
          if ('1' === rbd.bajaMatricula) {
            this.tablaGenerales.totalBajaMatricula += parseInt(rbd.bajaMatricula, null);
            this.tablaGenerales.totalMatriculaSinCat += parseInt(rbd.matBasica, null);
          }
          if ('1' === rbd.probInformacion) {
            this.tablaGenerales.estFaltaInfo += parseInt(rbd.probInformacion, null);
            this.tablaGenerales.totalMatriculaSinCatInformacion += parseInt(rbd.matBasica, null);
          }
      }
    });
  }

  filtrarGrilla(llave: string, valor: string, codigoTracking: number) {
    if (null !== codigoTracking) {
      this.tracking.trackear(null, codigoTracking, this.portalId);
    }
    this.storeGrilla = [];
    let storeTmp = [];
    if ('todo' !== llave) {

      if (isNaN(parseInt(valor, null))) {
        if ('conCat' === valor) {
          storeTmp = this.listaRBDAsociados.filter(x => x[llave] !== '99999');
        } else if ('sinCat' === valor) {
          storeTmp = this.listaRBDAsociados.filter(x => x[llave] === '99999');
        }
      } else {
        storeTmp = this.listaRBDAsociados.filter(x => x[llave] === valor);
      }
    } else {
      storeTmp = this.listaRBDAsociados;
    }
    this.storeGrilla = storeTmp;
  }

  descargarListado(): void {
    const elementos = [];
    this.storeGrilla.forEach(item => {
      elementos.push({
        RBD: item.rbd,
        Nombre_Establecimiento: item.nombreEstab,
        Region: item.regionLargo,
        Comuna: item.comuna,
        Dependencia: item.dependencia,
        Matrícula_Basica_2018: item.matBasica,
        Categoria_Desempeno_2019: item.getCategoriaDesempenoLiteral(item.categoriaDes2019)
      });
    });
    this.exportacionService.exportarExcel(elementos, 'Datos_Adminsitrativos');
  }

  setAnio(anio: number) {
    this.tablaGenerales = new ResultadoGeneralModel();
    this.anioSeleccion = anio;
    this.procesarResumen(this.listaRBDAsociados, anio);
  }

  descargarPDF(rbd: string) {
    this.documentosService.obtenerUrls(rbd, 'Basica', 'Director').subscribe(
      (next: any) => {
        if (next.a2019) {
          window.open(next.a2019, '_blank');
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  descargarPDFAu() {
    this.documentosService.obtenerUrlsSostenedor('Basica', this.userData.rut).subscribe(
      (next: any) => {
        if (next.a2019) {
          window.open(next.a2019, '_blank');
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  abrirLink(link: string) {
    window.open(link, '_blank');
  }

}
